import { css } from '@emotion/react'
import { Box } from '@mui/material'

import { PostsQuery } from 'generated/graphql.api'
import BlogListCard from '~/components/atoms/BlogListCard'

type Props = {
  data: PostsQuery
}

const BlogList: React.FC<Props> = ({ data }) => {
  const posts = data.posts

  return (
    <>
      <Box css={styles.wrapper}>
        {posts.map(item => {
          return (
            <Box key={item.slug} css={styles.cardWrapper}>
              <BlogListCard
                url={item.slug}
                src={item.coverImage.url}
                title={item.title}
                excerpt={item.excerpt}
                date={item.date}
                category={item.category}
              />
            </Box>
          )
        })}
      </Box>
    </>
  )
}

const styles = {
  wrapper: css`
    width: 100%;
    display: grid;
    grid-template-columns: 33% 33% 33%;
    justify-items: center;
    margin-left: 12px;
    @media (max-width: 1200px) {
      grid-template-columns: 50% 50%;
      margin-left: 0;
    }
    @media (max-width: 768px) {
      grid-template-columns: 100%;
      margin-left: 0;
    }
  `,
  cardWrapper: css`
    width: auto;
  `,
}

export default BlogList
